import React from 'react';
import { VisibilityOutlined } from '@mui/icons-material';

import { setExternalPreview, useProfile } from '../Session';
import './styles.css';

// Bouton des administrateurs : passer en « vue externe » (l'application vue par un compte externe : démos et projets
// partagés, viewer en lecture seule) et en revenir. Rien pour les autres comptes.
export default function ExternalPreviewButton({ className = '' }) {
  const profile = useProfile();
  if (!profile || (profile.role !== 'admin' && !profile.preview)) return null;
  const on = !!profile.preview;
  return (
    <button type="button" className={`external-preview-button${on ? ' on' : ''} ${className}`}
      onClick={() => setExternalPreview(!on)} aria-pressed={on}
      title={on
        ? 'You are seeing the app as an external account (your administrator rights stay active): click to go back to admin'
        : 'See the app as an external account: demos and shared projects, read-only viewer'}>
      <VisibilityOutlined fontSize="inherit" />
      {on ? 'External view · back to admin' : 'External view'}
    </button>
  );
}
